import * as React from "react";

import { UitkCardAloha, UitkCardAlohaContentSection } from "uitk-react-cards";
import {
  UitkFigureAspectRatioType as ExperimentalAspectRatioType,
  UitkImage as ExperimentalImage,
  UitkFigure as ExperimentalFigure,
} from "uitk-react-experimental-images";
import { UitkLayoutGrid, UitkLayoutGridItem, UitkLayoutConditionalGridColumnRow } from "uitk-react-layout-grid";
import { UitkLayoutFlex, UitkLayoutFlexItem, UitkLayoutFlexProps } from "uitk-react-layout-flex";
import { UitkExperimentalScrim, UitkScrimType as UitkExperimentalScrimType } from "uitk-react-experimental-scrim";
import { UitkSpacing, UitkSpacingProps } from "uitk-react-spacing";
import { SpacingSize } from "src/components/utility/FlexAttributesUtil";

export type ScrimCardProps = {
  id: string;
  dataTestId?: string;
  className: string;
  titleSlot?: JSX.Element | JSX.Element[];
  aspectRatio: ExperimentalAspectRatioType;
  backgroundImageURL: string;
  subtitleSlot?: JSX.Element | JSX.Element[];
  footerSlot?: JSX.Element | JSX.Element[];
  scrimType?: UitkExperimentalScrimType;
  marginClass?: string;
  spacing?: UitkSpacingProps;
  domRef?: React.RefObject<HTMLElement> | null;
  justifyContent?: UitkLayoutFlexProps["justifyContent"];
  mainGridColumns?: UitkLayoutConditionalGridColumnRow;
  headingCols?: UitkLayoutConditionalGridColumnRow;
  padding?: string;
  border?: boolean;
};

export const ScrimCard: React.FC<ScrimCardProps> = ({
  id,
  dataTestId = "scrim-card",
  className,
  titleSlot,
  aspectRatio,
  backgroundImageURL,
  subtitleSlot = null,
  footerSlot = null,
  scrimType = UitkExperimentalScrimType.OVERLAY,
  spacing = {},
  domRef = null,
  justifyContent = "space-between",
  mainGridColumns = { small: 1, medium: 2 },
  headingCols = { small: 1, medium: 2 },
  padding,
  border = true,
}) => {
  const subheadingCols: UitkLayoutConditionalGridColumnRow = { small: 1, medium: 1 };
  const hasNoPadding = padding === SpacingSize.NONE;
  const blockendSpacing = hasNoPadding ? "unset" : "six";

  return (
    <UitkSpacing padding={{ blockend: blockendSpacing }}>
      <section data-testid={dataTestId} id={id} ref={domRef}>
        <UitkSpacing {...spacing}>
          <UitkCardAloha className={className} border={border}>
            <UitkCardAlohaContentSection padded={false}>
              <ExperimentalFigure ratio={aspectRatio}>
                <ExperimentalImage alt="" src={backgroundImageURL} />
                <UitkExperimentalScrim type={scrimType}>
                  <UitkSpacing padding={{ inline: "three" }}>
                    <UitkLayoutFlex direction="column" justifyContent={justifyContent} style={{ height: "inherit" }}>
                      <UitkLayoutFlexItem>
                        <div>
                          {titleSlot && (
                            <UitkLayoutGrid columns={mainGridColumns}>
                              <UitkLayoutGridItem colSpan={headingCols}>{titleSlot}</UitkLayoutGridItem>
                            </UitkLayoutGrid>
                          )}

                          {subtitleSlot && (
                            <UitkSpacing padding={{ blockstart: "three" }}>
                              <UitkLayoutGrid columns={mainGridColumns}>
                                <UitkLayoutGridItem colSpan={subheadingCols}>{subtitleSlot}</UitkLayoutGridItem>
                              </UitkLayoutGrid>
                            </UitkSpacing>
                          )}
                        </div>
                      </UitkLayoutFlexItem>
                      {footerSlot && (
                        <UitkLayoutFlexItem>
                          <div>{footerSlot}</div>
                        </UitkLayoutFlexItem>
                      )}
                    </UitkLayoutFlex>
                  </UitkSpacing>
                </UitkExperimentalScrim>
              </ExperimentalFigure>
            </UitkCardAlohaContentSection>
          </UitkCardAloha>
        </UitkSpacing>
      </section>
    </UitkSpacing>
  );
};
